import { useNavigate as useNavigateOriginal } from 'react-router-dom';

/**
 * パスを引数にしてナビゲーションを行う
 * @returns ナビゲーション関数
 */
export const useNavigate = () => {
  const navigate = useNavigateOriginal();

  return (path: string) => {
    navigate(path);
  };
};
